import Axios from "axios";
import { API_URL } from "../config";
import { removeUser } from "../redux/slices/userSlice";
import store from "../redux/store";

const axiosInstance = Axios.create({
  baseURL: API_URL,
  headers: {
    Accepted: "appication/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (typeof error.response.data === "undefined") {
      store.dispatch(removeUser());
      window.open = "/";
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export const axios = axiosInstance;
